import PropTypes from 'prop-types';
export default {
  thumbnails: PropTypes.bool,
  navButtons: PropTypes.bool
};